export const TOKEN_URL = `${process.env.REACT_APP_AUTH_SERVER_URL}/realms/techsophy-platform/protocol/openid-connect/token`;
export const GENERATE_OTP_URL = `${process.env.REACT_APP_API_SERVER_URL}/accounts/v1/otp/generate`;
export const VALIDATE_OTP_URL = `${process.env.REACT_APP_API_SERVER_URL}/accounts/v1/otp/validate`;
export const FORM_DATA_URL = `${process.env.REACT_APP_API_SERVER_URL}/form-runtime/v1/form-data`;
export const FORM_MODELER_URL = `${process.env.REACT_APP_API_SERVER_URL}/form-modeler/v1/forms`;
export const XANO_API_URL = `${process.env.REACT_APP_XANO_API_URL}`;
